import './libraries/slimmageSettings';
import './libraries/slimmage';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';
import ConsentController from '@neworange-agency-db/consent-controller';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
    
        app.polyfillController = polyfills;
    
        app.consentController = new ConsentController();
        app.headerController = new HeaderController();
        app.mediaController = new MediaController();

        // Modules
        const loadModules = () => {
            if (document.querySelector('.shareContainer')) {
                import( /* webpackChunkName: "modules/share" */ './controllers/share/controller').then(e => {
                    app.shareController = new e.default();
                });
            }

            if (document.querySelector('.splide')) {
                import( /* webpackChunkName: "modules/slider" */ './controllers/slider').then(e => {
                    app.sliderController = new e.default();
                });
            }

            if (document.querySelector('[data-gallery]')) {
                import( /* webpackChunkName: "modules/gallery" */ './controllers/gallery').then(e => {
                    app.galleryController = new e.default();
                });
            }

            if (document.querySelector('section.projectsOverview')) {
                import( /* webpackChunkName: "modules/projectsOverview" */ './controllers/projectsOverview').then(e => {
                    app.projectsOverviewController = new e.default();
                });
            }

            if (app.getParameter('debugger')) {
                import( /* webpackChunkName: "modules/console" */ './controllers/debugger').then(e => {
                    app.debuggerController = new e.default();
                });
            }

            if (document.querySelector('.blSubmenu')) {
                import( /* webpackChunkName: "modules/submenu" */ './controllers/submenu').then(e => {
                    app.submenuController = new e.default();
                });
            }
        };

        loadModules();

        // * Remove when done: Testing purposes
        // app.insertBreakpointIndicator();
        // app.insertColumnTester();

        await app.init();
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');

})();